const CURRENCY_REGEX = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;

export const isValidCurrency = (amount?: number) => {
  if (!amount) {
    return false;
  }

  return CURRENCY_REGEX.test(`${amount}`);
};
